import { logout as clearBackendSession } from "../Api/services/auth/authClient";
import { createLogger } from "../../utils/logger";

const logger = createLogger("ManualLogout");

/**
 * Custom hook for logging out (manual implementation without Auth0 SDK)
 * @returns {logout: () => Promise<void>}
 * @constructor
 */
export const useAuth0Logout = () => {
    const logout = async (): Promise<void> => {
        try {
            // Clear backend session
            await clearBackendSession();
            logger.info("Backend session cleared");

            // Clear sessionStorage (PKCE values)
            sessionStorage.removeItem("oauth2_code_verifier");
            sessionStorage.removeItem("oauth2_state");
            logger.info("SessionStorage cleared");

            // Redirect to login page
            logger.info("Redirecting to login page");
            window.location.href = "/access-content-manager";
        } catch (error) {
            logger.error("Logout error:", error);
            // Even if backend logout fails, clear local state and redirect
            sessionStorage.clear();
            window.location.href = "/access-content-manager";
        }
    };

    return { logout };
};
